<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">  
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord()"
    />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "CellRendererEditSession",
  methods: {
    editRecord() {      
        this.$root.$emit("openMappingPopUp", this.params.session);
    },
    confirmDeleteRecord() {
          const { value: text } = Swal.fire({
          title: `You are about to delete "${this.params.session.Name}"`,
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecord();
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        })
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess();
      this.$vs.loading();
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch("agendaManagement/removeSessionMapping", this.params.session)
        .then(()   => { 
          this.$store.dispatch("sessionManagement/fetchSessionsMapping")
          this.$vs.loading.close();
          this.showDeleteSuccess() 
        })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        //title: "User Deleted",
        text: "The selected session was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully"
      });
    }
  }
};
</script>
